'use client';

import { useRouter } from 'next/navigation';
import { isValidRoomName } from '@/lib/rooms/client-utils';

import { useTranslations } from '@/i18n/useTranslations';
import { useWebHaptics } from 'web-haptics/react';

import { DotLottieReact } from '@lottiefiles/dotlottie-react';

import RoomInput from '@/ui/components/RoomInput';
import NewRoomButton from '@/ui/components/NewRoomButton';

import neoCallAnim from '@/assets/logos/neocall.json';

import elements from '@/styles/elements.module.sass';
import button from '@/styles/button.module.sass';
import text from '@/styles/text.module.sass';
import styles from './MainPage.module.sass';

export default function MainPage() {
  const { t } = useTranslations('HomePage');
  const { trigger } = useWebHaptics();

  const router = useRouter();

  const joinExistingRoom = (roomName: string) => {
    const name = roomName.trim();
    trigger('success');
    if (name !== '' && isValidRoomName(name)) {
      router.push(`/${name}`);
    }
  };
  return (
    <>
      <div className={styles.logoWrapper}>
        <DotLottieReact
          className={`${styles.logoAnim} ${elements.themeDependentAndBright}`}
          data={neoCallAnim}
          autoplay
          loop
        />
        <p className={text.pBold}>Neo Calls</p>
      </div>
      <div className={button.vWrapper}>
        <NewRoomButton />
        <RoomInput
          className={styles.inputWrapper}
          onJoinAction={joinExistingRoom}
          placeholderLabel={t('existingRoom')}
        />
      </div>
    </>
  );
}
